import io from 'socket.io-client';
import { GameModes } from 'types/enums';
import { getApiUrl } from '../helpers/get-api-url';

export class WebsocketGameService {
    public ws: typeof io.Socket | null;

    constructor() {
        this.ws = null;
    }

    init(operatorId?: string | null, game?: string, token?: string): void {
        const connectionURL = getApiUrl(window.env.REACT_APP_WS_URL) || '';
        this.ws = io.connect(connectionURL, {
            path: `/games/${game}`,
            transports: ['websocket'],
            reconnection: true,
            query: {
                Authorization: token || (game === GameModes.JACKPOT ? '' : null),
                operatorId: operatorId,
            },
        });
    }
}